import { render, staticRenderFns } from "./FormItemRadioButtons.vue?vue&type=template&id=19d5c135&scoped=true"
import script from "./FormItemRadioButtons.vue?vue&type=script&lang=js"
export * from "./FormItemRadioButtons.vue?vue&type=script&lang=js"
import style0 from "./FormItemRadioButtons.vue?vue&type=style&index=0&id=19d5c135&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d5c135",
  null
  
)

export default component.exports